import CatatanPemeriksaan from "../../../../../components/categories/operational/qr_patrol/catatan_pemeriksaan/Home";
export default function Home() {
  
  return (
    <CatatanPemeriksaan />
  );
}
